import React from "react";
import {
  deserialize,
  getResourceCollection,
  getResourceCollectionFromContext,
} from "next-drupal";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Pager from "components/Pager";
import Header from "components/Header";
import Meta from "components/Meta";
import NodePublicationList from "components/Publication/NodePublicationList";
import Image from "next/image";

export const NODES_PER_PAGE = 6;

export default function NewslettersPage({ globals, nodes, newses, partners, page }) {
  const crumbs = [
    {
      path: "/",
      title: "Accueil",
    },
    {
      title: "Newsletters",
    },
  ];

  return (
    <Layout globals={globals} newses={newses} partners={partners}>
      <Meta
        title="Newsletters"
        description="Retrouvez toutes les newsletters d'Interco' Outre-mer"
      />
      <Header crumbs={crumbs} title="Newsletters" />
      <section className="pb-16 bg-white relative overflow-hidden">
        <div
          className="absolute -left-60 top-0 scale-75 opacity-20"
          style={{
            width: "30vw",
            height: "30vw",
          }}
        >
          <Image
            src="/images/decorations/lightblue-martinique.svg"
            height={571}
            width={490}
            alt="Réprésentation de la Martinique"
          />
        </div>
        <div
          className="absolute -right-40 top-0 opacity-20"
          style={{
            width: "30vw",
            height: "30vw",
          }}
        >
          <Image
            src="/images/decorations/lightblue-mayotte.svg"
            height={571}
            width={490}
            alt="Réprésentation de Mayotte"
          />
        </div>
        <div className="container mx-auto px-4">
          {nodes?.length ? (
            <NodePublicationList nodes={nodes} />
          ) : (
            <p className="py-4">Aucun contenu trouvé</p>
          )}

          {page && (
            <Pager
              current={page.current}
              total={page.total}
              path="/newsletters"
            />
          )}
        </div>
      </section>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const params = new DrupalJsonApiParams();
  const newsesParams = new DrupalJsonApiParams();
  const partnersParams = new DrupalJsonApiParams();

  params
    .addInclude(["field_file"])
    .addPageLimit(NODES_PER_PAGE)
    .addFilter("status", 1)
    .addSort("created", "DESC");

  newsesParams
    .addInclude(["field_image", "field_type"])
    .addFilter("status", 1)
    .addSort("created", "DESC")
    .addSort("title", "ASC")
    .addPageLimit(3);

  partnersParams
    .addInclude(["field_image"])
    .addFilter("status", 1)
    .addSort("title", "ASC");

  const results = await getResourceCollectionFromContext(
    "node--newsletter",
    context,
    {
      deserialize: false,
      params: params.getQueryObject(),
    }
  );

  const newses = await getResourceCollection("node--news", {
    params: newsesParams.getQueryObject(),
  });

  const partners = await getResourceCollection("node--partners", {
    params: partnersParams.getQueryObject(),
  });

  return {
    props: {
      globals: await getGlobals(context),
      nodes: deserialize(results),
      partners,
      newses,
      page: {
        current: 1,
        total: Math.ceil(results.meta.count / NODES_PER_PAGE),
      },
    },
    revalidate: 30,
  };
}
